import { createGlobalStyle } from "styled-components";

const Style = createGlobalStyle`
    .action-wrap{
        overflow: auto;
        height: calc(100vh);
        -ms-overflow-style: none;
        scrollbar-width: none;
            ::-webkit-scrollbar {
              display: none;
            }
        padding: 25px;
        .input-time{
            background-position: center right;
            background-repeat: no-repeat;
            background-origin: content-box;
        }
        .head-wrap{
            .head-left{
                img{
                    transform: rotate(90deg);
                }
            }
            .head-right{
                .ghost-form-button{
                    border: 2px solid #BDFF00;
                    border-radius: 24px;
                    background: transparent;
                    padding: 6px 40px;
                }
            }
        }
        .action-body-wrap{
            overflow: auto;
            height: calc(100vh - 80px);
            -ms-overflow-style: none;
            scrollbar-width: none;
            ::-webkit-scrollbar {
              display: none;
            }
            .mobile-screen{
                background-repeat: no-repeat!important;
                width: 358px;
                background-size: contain!important;
                padding: 0 25px;
                padding-top: 40px;
                height: 640px;
                .iphone-frame{
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 319px;
                    height: 620px;
                    z-index: 9;
                }
                .background-mobile{
                    position: absolute;
                    width: 287px;
                    height: 620px;
                    left: 19px;
                    top: 0;
                    border-radius: 50px;
                }
                .mobile-header{
                    border-radius: 0 0 20px 20px;
                    padding-top: 37px!important;
                }
                .mobile-body{
                    .mobile-card{
                        border-radius: 10px;
                        svg{
                            width: 32px;
                            height: 32px;
                        }
                    }
                }   
                .mobile-nav{
                    margin: 0 8px;
                    border-radius: 30px;
                    padding: 15px 13px;
                    svg{
                        width: 20px;
                        height: 20px;
                    }
                }
            }

            .color-picker{
                background-repeat: no-repeat!important;
                background-position: center right!important;
                background-origin: content-box!important;
            }
            .color-picker-wrap{
                top: -230px;
                z-index: 9;
            }
        }
        .Time-wrapper{
            .react-timekeeper__top-bar{
                background: #282828;
                .react-timekeeper-button-reset{
                    color : white;
                    opacity: 0.5;
                }
                .react-timekeeper__tb-minute-wrapper{
                    .react-timekeeper__tb-hour{
                        color: #FFFFFF;
                        opacity: 0.5;
                    }
                    .react-timekeeper__tb-hour--active{
                        opacity: 1;
                    }
                }
                .react-timekeeper__tb-hour-wrapper{
                    .react-timekeeper__tb-minute{
                        color: #FFFFFF;
                        opacity: 0.5;
                    }
                    .react-timekeeper__tb-minute--active{
                        opacity: 1;
                    }
                }
            }
            .react-timekeeper__clock-wrapper{
                background: #646464;
                .react-timekeeper__clock{
                    background: #282828;
                    .react-timekeeper__clock-minutes{
                        color: white;
                    }
                    .react-timekeeper__clock-hand{
                        stroke: var(--hand-line-color,#BDFF00);
                    }
                    .react-timekeeper__hand-circle-center{
                        fill: var(--hand-circle-center,#BDFF00);
    
                    }
                    .react-timekeeper__hand-circle-outer{
                        fill: var(--hand-circle-outer,#BDFF00);
                    }
                }
                .react-timekeeper-button-reset{
                    color: #282828;
                }
                .react-timekeeper__meridiem-toggle{
                    background:  #A0A0A0;                
                }
                .react-timekeeper__meridiem--active{
                    background:  #BDFF00;
                }
            }
            .input-time{
                background-position: center right;
                background-repeat: no-repeat;
                background-origin: content-box;
            }
            .time-wrap-div{
                top: -210px;
                z-index: 99;
            }
        }
    }
`;

export default Style;